const SendInputArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
    >
      <path
        d="M12.4209 4.90258L2.49075 0.782148C2.0724 0.608542 1.59978 0.684913 1.25736 0.981355C0.914928 1.27785 0.771706 1.73467 0.883629 2.17354L1.7675 5.6397H6.09505C6.29419 5.6397 6.45565 5.80114 6.45565 6.0003C6.45565 6.19943 6.29421 6.3609 6.09505 6.3609H1.7675L0.883629 9.82703C0.771706 10.2659 0.914904 10.7228 1.25736 11.0192C1.60048 11.3163 2.07315 11.3917 2.49077 11.2184L12.4209 7.09802C12.873 6.91042 13.1539 6.4898 13.1539 6.0003C13.1539 5.5108 12.873 5.09016 12.4209 4.90258Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SendInputArrowIcon;
